













































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { dictServe, getSignatureServer, institutionServer, performanceServer } from '@/api/installServer';
import ChooseDeptOfStaff from '@/views/inspectionContents/checklist/unit/choosePeople.vue';
import checkDialog from '@/views/inspectionContents/checklist/unit/checkDialog.vue';
import { arrayToTree } from '@/util/arrayToTree';
import { deepClone } from '@/util/deepClone';

@Component({
  components: { CollapseTransition, PagingUnit, ChooseDeptOfStaff, checkDialog },
  mixins: [TableStripe],
})
export default class AddCheck extends Vue {
  sidePic: any = require('@/assets/img/base/sidePic.png');
  formData: any = {
    startCheckDate: '', // 发起时间
    endCheckDate: '', // 结束时间
    inspectedList: [], // 被检单位
    checkUtils: [], // 检查部门
    checkItemIds: [], // 检查项
    executors: [], // 执行人
    checkBigCategory: '例行检查', // 检查大类
    checkType: '单位级', // 检查级别
    description: '', // 补充内容
    securityCheckTemplateId: '', // 检查模板id
  };
  private subSpaceByAuthOptions: any = [];
  private checkBigCategoryOption: any = []; // 检查类别
  private checkTypeOption: any = []; // 检查级别

  private executorsSign: any = [];

  private saveLoading: any = false;

  async created() {
    // 进入页面时 检查部门默认选择当前人员的部门
    const info: any = localStorage.getItem('userInfo');
    const userInfo: any = JSON.parse(info);
    this.formData.checkUtils = [userInfo.deptId];
    this.formData.executors = [{ id: userInfo.staffId, name: userInfo.staffName }];
    this.getSubSpaceByAuth();
    this.getCheckBigCategoryOption(); // 检查类别
    this.getCheckTypeOption(); // 检查级别
    const resInner: any = await this.getStaffSignatureByStaffId(userInfo.staffId);
    if (resInner && resInner.signature) {
      this.executorsSign = [resInner.signature];
    } else {
      this.executorsSign = [];
    }
  }

  /**
   * @desc 选择执行人的弹窗
   * */
  choseSponsor(type: any) {
    const chooseStaffArr: any = deepClone(this.formData.executors);
    (this.$refs['ChooseDeptOfStaff'] as any).showDialog(chooseStaffArr, 'more');
  }

  getStaffData(data: any) {
    this.formData.executors = data;
    this.executorsSign = [];
    data.forEach(async (i: any) => {
      const resInner: any = await this.getStaffSignatureByStaffId(i.id);
      if (resInner && resInner.signature) {
        this.executorsSign.push(resInner.signature);
      }
    });
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  async getSignatureData(id: any) {
    if (id) {
      const res: any = await performanceServer.getStaffInfo(id);
      if (res.code === '200') {
        if (res.data) {
          return res.data;
        } else {
          return '';
        }
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  // 获取签名图片 根据人员id
  async getStaffSignatureByStaffId(staffId: any) {
    const res: any = await getSignatureServer.getStaffSignatureByStaffId(staffId);
    if (res.code === '200' && res.data) {
      return res.data;
    } else {
      return '';
    }
  }

  /* el-image图片放大时的默认旋转 */
  private imgPreview(e: any) {
    setTimeout(() => {
      const dom: any = document.getElementsByClassName('el-image-viewer__img');
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.transform = 'scale(1) rotate(270deg)';
      }
    });
  }

  /**
   * @desc 选择检查内容的弹窗
   * */
  showCheckDialog() {
    const checkDialog = 'checkDialog';
    const checkDialogComponent = this.$refs[checkDialog];
    (checkDialogComponent as any).showDialog(this.formData.checkItemIds); // 传给弹窗的数据 检查标准项(即 检查内容)
  }

  /**
   * @desc 检查内容弹窗中所选的数据
   * */
  getTemplateData(data: any) {
    this.formData.securityCheckTemplateId = data.securityCheckTemplateId ? data.securityCheckTemplateId : '';
    this.formData.checkItemIds = data.choiceList;
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  private getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getAllData({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  // 检查类别
  private getCheckBigCategoryOption() {
    dictServe.getDetailsMapByName('securityCheckBigCategory').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            label: res.data[key],
            value: key,
          });
        }
        this.checkBigCategoryOption = helpArr;
      } else {
        this.$message.warning('获取检查类别数据失败！');
      }
    });
  }

  // 检查级别
  private getCheckTypeOption() {
    dictServe.getDetailsMapByName('securityCheckType').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            label: res.data[key],
            value: key,
          });
        }
        this.checkTypeOption = helpArr;
      } else {
        this.$message.warning('获取检查级别数据失败！');
      }
    });
  }

  backToIndex() {
    this.$emit('backToIndex');
  }

  saveForm() {
    this.saveLoading = true;
    const checkItemIds: any = this.formData.checkItemIds.map((item: any) => item.id);
    const executors: any = this.formData.executors.map((item: any) => item.id);

    performanceServer
      .addTask({
        ...this.formData,
        checkItemIds: checkItemIds,
        executors: executors,
        joinLeaderIds: [],
        joinStaffIds: [],
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('新增成功！');
          this.saveLoading = false;
          this.backToIndex();
        } else {
          this.$message.warning(res.msg);
          this.saveLoading = false;
        }
      });
  }
}
